import { Cross, Tick } from "components/icons/generated";
import Icon from "ds/components/Icon";
import Typography from "ds/components/Typography";
import Box from "ds/components/Box";
import { IconComponent } from "types/Icon";
import TooltipInfo from "ds/components/TooltipInfo";

type BillingFeatureItemIconProps =
  | {
      negative?: boolean;
      iconComponent?: never;
    }
  | {
      negative?: never;
      iconComponent: IconComponent;
    };

type BillingFeatureItemProps = {
  text: string;
  infoTooltip?: string;
} & BillingFeatureItemIconProps;

const BillingFeatureItem = ({
  text,
  negative,
  iconComponent,
  infoTooltip,
}: BillingFeatureItemProps) => {
  return (
    <Box gap="medium" align="start">
      {iconComponent && <Icon src={iconComponent} noShrink />}
      {!iconComponent && (
        <>
          {negative ? (
            <Icon src={Cross} color="danger" noShrink />
          ) : (
            <Icon src={Tick} color="success" noShrink />
          )}
        </>
      )}

      <Box grow="1">
        <Typography tag="p" variant="p-body3">
          {text}
        </Typography>
      </Box>
      {infoTooltip && (
        <Box shrink="0">
          <TooltipInfo widthMode="maxWidthSm">{infoTooltip}</TooltipInfo>
        </Box>
      )}
    </Box>
  );
};

export default BillingFeatureItem;
